const env = process.env.REACT_APP_HOST_NODE_ENV || 'production';

//export const API_URL = "http://dev.api.engage360.evacompute.com:3000/api/v1/";
export const currentPage = 1;
export const currentScrollingPage = 0;
export const itemPerPage = 20;
export const ERROR_MSG = 'Something went wrong, Please try again later!'

var host = '';
var port = '3000';
var scheme = '';
var msgHost = '';
var msgPort = '4000';
var webSocketUrl='';
var webSocketPort='';
var webSocketSchema='';


if (env === 'dev' || env === 'development' || env === 'staging') {
	host = 'dev.api.engage360.evacompute.com'
	scheme = 'http'
	msgHost = 'dev.api.engage360.evacompute.com'
	webSocketUrl='dev.api.engage360.evacompute.com'
	webSocketPort=8000
	webSocketSchema='ws'
}
if (env === 'local' || env === 'localhost') {
	host = 'localhost'
	scheme = 'http'
	msgHost = 'localhost'
	webSocketUrl='localhost'
	webSocketPort=8000
	webSocketSchema='ws'

}
if (env === undefined || env === 'production') {
	host = 'api.engage360.evacompute.com'
	msgHost = 'messaging.engage360.evacompute.com'
	port = ''
	scheme = 'https'
	msgPort = '443'
	webSocketUrl='api.engage360.evacompute.com'
	webSocketPort=8000
	webSocketSchema='wss'
}

export const HOST =  host  //'localhost' //'dev.api.engage360.evacompute.com'
export const PORT =  port  //'3000'
export const SCHEME = scheme

export const MSGHOST =  msgHost
export const MSGPORT =  msgPort

export const API_URL = SCHEME + "://" + HOST + ":" + PORT + "/api/v1/"
export const API_URL_V2 = SCHEME + "://" + HOST + ":" + PORT + "/api/v2/"
export const API_URL_V3 = SCHEME + "://" + HOST + ":" + PORT + "/api/v3/"

export const MSG_URL = "http://" + MSGHOST + ":" + MSGPORT + "/api/v1/"
export const BEARER_TOKEN = localStorage.getItem('token')
export const WEBSOCKET_PORT=webSocketPort
export const WEBSOCKET_URL=webSocketUrl
export const WEBSOCKET_SCHEMA=webSocketSchema


